import { THEME_STATUS } from "../constants";
const defaultGetTemplateListFilterOption = {
  group: true,
  // 过滤显示分组
  status: true // 过滤主题类型当前状态（过滤停用，删除）
};
const filterTemplate = (template, userGroups, filter) => {
  const {
    groups = [],
    status
  } = template;
  // 过滤主题类型 当前状态（过滤停用，删除）
  if (filter.status) {
    if (status === THEME_STATUS.stop || status === THEME_STATUS.del) return false;
  }
  // 过滤分可见
  if (filter.group) {
    if (groups === null || groups.includes('-1')) return true;
    let flag = false;
    userGroups.forEach(group => {
      if (groups.includes(group)) flag = true;
    });
    return flag;
  }
  return true;
};

/**
 * 获取模板列表
 * 过滤用户权限
 */
export const getNormalTemplateMap = props => {
  const {
    templateList,
    orgRole,
    userGroups,
    filterOption
  } = props;
  const mergedFilterOption = {
    ...defaultGetTemplateListFilterOption,
    ...filterOption
  };
  if (orgRole === 1 || orgRole === 3) {
    userGroups.push('-2');
  }
  return templateList.reduce((map, template) => {
    const check = filterTemplate(template, userGroups, mergedFilterOption);
    if (!check) {
      return map;
    } else {
      map[template.template_id] = template;
      return map;
    }
  }, {});
};

/**
 * 获取可新增的主题类型id
 */
export const getChildTempAllow = props => {
  const {
    tempId,
    tempMap,
    tempList
  } = props;
  if (!tempMap && !tempList) {
    return [];
  }
  const temp = tempMap ? tempMap[tempId] : tempList?.find(x => x.template_id === tempId);
  const allowTemps = temp?.childTemp?.allow || [];
  let allowAll = temp?.childTemp?.allowAll;
  // allowAll默认值 如果没有设置过，
  // 并且allowTemps是空 那就是true
  if (allowAll === undefined) {
    allowAll = !allowTemps.length;
  }
  if (allowAll === true) {
    return tempMap ? Object.keys(tempMap) : (tempList || []).map(x => x.template_id);
  }
  return allowTemps;
};